import { useAuditMatchPlaybackControl } from '@app/modules/audit/modules/station-audit/hooks/useAuditMatchPlaybackControl';
import { AuditMatch } from '@app/modules/audit/modules/station-audit/types';
import PauseIcon from '@mui/icons-material/Pause';
import PlayIcon from '@mui/icons-material/PlayArrow';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const playMessage = defineMessage({
  id: 'common.play',
  defaultMessage: 'Reproducir',
});

const pauseMessage = defineMessage({
  id: 'common.pause',
  defaultMessage: 'Pausar',
});

type AuditMatchPlayPauseButtonProps = {
  match: AuditMatch;
};

/**
 * Controls audit-match playback without closing the popup, allowing pause from the same action.
 */
export function AuditMatchPlayPauseButton({ match }: AuditMatchPlayPauseButtonProps) {
  const { $t } = useIntl();
  const { showPause, handleClick } = useAuditMatchPlaybackControl(match);
  const tooltip = showPause ? $t(pauseMessage) : $t(playMessage);

  return (
    <Tooltip title={tooltip} placement="top">
      <IconButton size="small" color="secondary" onClick={handleClick}>
        {showPause ? <PauseIcon fontSize="small" /> : <PlayIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
